import React, { useRef, useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  Tab,
  Tabs,
  IconButton,
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  TextField,
  InputAdornment,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { HCE_MENU_INFORMACION } from '../../../../utils/constants';
import { TabDocumentacionHce } from './TabDocumentacionHce';
import { TabAnalisis } from './TabAnalisis';
import { TabInformes } from './TabInformes';
import { TabResumen } from './TabResumen';
import { TabDiagnosticos } from './TabDiagnosticos';
import { TabOdontologia } from './TabOdontologia';
import { AddAlert, Close, Exposure, Save } from '@material-ui/icons';
import { TabTurnos } from './TabTurnos';
import { ingresarCelularContacto, marcarTurnoAtendido } from '../../../../actions/hce/hceActions';
import { TabRecetas } from './ResumenHCE/TabRecetas';
import { TabMedicacionIndicada } from './TabMedicacionIndicada';
import { TabEstudiosSolicitados } from './TabEstudiosSolicitados';
import { TabEnfermeria } from './TabEnfermeria';
import { TabOftalmologia } from './TabOftalmologia';
import { CertificadoAtencion } from './CertificadoAtencion/CertificadoAtencion';
import { useReactToPrint } from 'react-to-print';
import { ModalAltaTurno } from './ResumenHCE/ModalAltaTurno';
import { ModalOpciones } from '../../../shared/ModalOpciones';
import { ModalTurnoDemandaLaboratorio } from '../../../turnos/recepcionDiaria/laboratorio/ModalTurnoDemandaLaboratorio';
import { laboratorioClear } from '../../../../actions/turnos/laboratorio';
import { changeStepper } from '../../../../actions/preAfiliado/stepper';
import { efectorHorariosLimpiar } from '../../../../actions/turnos/efectorHorarios';
import { TabConsumos } from './TabConsumos';
import { TabSolicitudesProfesional } from './tabSolicitudesProfesional/TabSolicitudesProfesional';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    whiteSpace: "pre-line",
    flex: 1,
  },
  background: {
    backgroundColor: theme.palette.grey[50],
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      name={index}
      {...other}
    >
      {value === index && <Box p={2}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export const ModalHce = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { piso, consultorio, disabled, idEfectorRed } = props;
  
  const {
    hceSeleccionada = {},
    dataAfiliado,
    problemas,
    estadosProblemas,
    autopercepcionAfi,
    relEfectorCMEspe,
    // hce
  } = useSelector((state) => state.hce);
  
  const [selectedTab, setSelectedTab] = useState(HCE_MENU_INFORMACION.RESUMEN);
  const [openDemandaLaboratorio, setOpenDemandaLaboratorio] = useState(false);
  const [openOptionsDemanda, setOpenOptionsDemanda] = useState(false);
  const [celular, setCelular] = useState(hceSeleccionada?.celular);
  const [openModalTurno, setOpenModalTurno] = useState(false);
  const [open, setOpen] = useState(false);      

  const llamarPaciente = () => {
    const datos = {
      idAgenda: hceSeleccionada.idAgenda,
      piso: piso,
      consultorio: consultorio

    }
    dispatch(marcarTurnoAtendido(datos));
  }

  const guardarCelular = () => {
    const datos = {
      idAfiliado: hceSeleccionada.idAfiliado,
      celular: celular,
    }
    dispatch(ingresarCelularContacto(datos));
  }


  const handleClose = () => {
    setOpen(false);
  };

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrintRow = () => {
    handlePrint();
    setOpen(false);
  };

  // console.log("hce modal", hce)
  return (
    <>
      {openModalTurno && (
        <ModalAltaTurno
          open={openModalTurno}
          closeModalHandler={() => setOpenModalTurno(false)}
          afiliado={dataAfiliado}
          idEfectorRed={idEfectorRed}     
          relEfectorCMEspe={relEfectorCMEspe}  
          hce={hceSeleccionada}
        />
      )}
      {openOptionsDemanda &&
        <ModalOpciones
          open={openOptionsDemanda}
          title={"PROXIMA VISITA / SOLICITAR LABORATORIO"}
          opciones={[
            'PROXIMA VISITA', 
            'SOLICITAR LABORATORIO'
          ]}
          onCloseModal={() => setOpenOptionsDemanda(false)}
          onChoseOption={(option) => {                      
            if(option === 0){
              setOpenModalTurno(true)
            }
            else{
              dispatch( changeStepper(0) )
              dispatch( laboratorioClear() )
              dispatch( efectorHorariosLimpiar() );
              setOpenDemandaLaboratorio(true)
            }
            setOpenOptionsDemanda(false)
          }}
        />
      }
      {openDemandaLaboratorio &&
        <ModalTurnoDemandaLaboratorio
          desdeHce={true}
          hce={props.hce}
          open={openDemandaLaboratorio}
          title={"Ingreso de Prácticas Laboratorio"}
          onCloseModal={() => setOpenDemandaLaboratorio(false)}                    
        />
      }
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">
        <DialogContent className={classes.background}>
          <CertificadoAtencion
            hceSeleccionada={hceSeleccionada}
            handleClose={handleClose}
            handlePrintRow={handlePrintRow}
            componentRef={componentRef}
            modal
            relEfectorCMEspe={relEfectorCMEspe}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        fullScreen
        maxWidth="xl"
        open={props.open}
        onClose={props.closeModalHandler}
      >
        {/* <DialogTitle style={{ position: 'relative' }}>
          <span style={{ float: 'left' }}>
            HCE - Afiliado: {hce?.nombreApellido}
          </span>
          <IconButton
            edge="start"
            color="inherit"
            onClick={props.closeModalHandler}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle> */}
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={props.closeModalHandler}
              aria-label="close"
            >
              <Close />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Historia Clínica Electrónica - {dataAfiliado?.apellido_y_nombre}
            </Typography>
            {!disabled &&
              <IconButton
                edge="end"
                color="inherit"
                onClick={() => {
                  if(hceSeleccionada?.idAfiliado)
                    setOpenOptionsDemanda(true)
                  else
                    setOpenModalTurno(true)
                }}
              >
                <Typography variant="h6" className={classes.title} style={{fontSize: 18, marginRight: 15}}>
                  {"PROXIMA VISITA / \n SOLICITAR LABORATORIO"}                  
                </Typography>
                <Exposure style={{ fontSize: 35 }} />
              </IconButton>
            }
            <TextField
              id="filled-secondary"
              variant="filled"
              label="Celular de contacto"
              value={celular}
              onChange={(e) => setCelular(e.target.value)}
              style={{ backgroundColor: 'white', margin: 10 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {/* Botón para guardar el celular */}
                    <IconButton
                      color="inherit"
                      aria-label="guardar"
                      onClick={guardarCelular}
                    >
                      <Save />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {!disabled &&
              <IconButton
                edge="end"
                color="inherit"
                onClick={llamarPaciente}
                aria-label="close"
                disabled={disabled}

              >
                <Typography variant="h6" className={classes.title}>
                  Llamador
                </Typography>
                <Box width={10} />
                <AddAlert style={{ fontSize: 40 }} />
              </IconButton>
            }

          </Toolbar>
        </AppBar>
        <DialogContent
          style={{ overflowY: 'auto', maxHeight: '100vh', maxWidth: '100vw' }}
        >
          <Tabs
            value={selectedTab}
            onChange={(_event, newValue) => setSelectedTab(newValue)}
            indicatorColor="primary"
            textColor="primary"
            scrollButtons="auto"
            variant="scrollable"
          >
            <Tab
              value={HCE_MENU_INFORMACION.RESUMEN}
              label="Resumen"
              {...a11yProps(HCE_MENU_INFORMACION.RESUMEN)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.DIAGNOSTICOS}
              label="Problemas"
              {...a11yProps(HCE_MENU_INFORMACION.DIAGNOSTICOS)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.MEDICACION_INDICADA}
              label="Medicación Activa"
              {...a11yProps(HCE_MENU_INFORMACION.MEDICACION_INDICADA)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.ENFERMERIA}
              label="Enfermería"
              {...a11yProps(HCE_MENU_INFORMACION.ENFERMERIA)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.ESTUDIOS_SOLICITADOS}
              label="Estudios Solicitados"
              {...a11yProps(HCE_MENU_INFORMACION.ESTUDIOS_SOLICITADOS)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.RECETAS}
              label="Recetas"
              {...a11yProps(HCE_MENU_INFORMACION.RECETAS)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.INFORMES}
              label="Informes"
              {...a11yProps(HCE_MENU_INFORMACION.INFORMES)}
            />
            {/* <Tab
              value={HCE_MENU_INFORMACION.ANALISIS_CLINICOS}
              label="Análisis Clínicos / Imágenes"
              {...a11yProps(HCE_MENU_INFORMACION.ANALISIS_CLINICOS)}
            /> */}
            <Tab
              value={HCE_MENU_INFORMACION.OFTALMOLOGIA}
              label="Oftalmología"
              {...a11yProps(HCE_MENU_INFORMACION.OFTALMOLOGIA)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.ODONTOLOGIA}
              label="Odontología"
              {...a11yProps(HCE_MENU_INFORMACION.ODONTOLOGIA)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.TURNOS}
              label="Turnos"
              {...a11yProps(HCE_MENU_INFORMACION.TURNOS)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.CONSUMOS}
              label="Consumos"
              {...a11yProps(HCE_MENU_INFORMACION.CONSUMOS)}
            />
            <Tab
              value={HCE_MENU_INFORMACION.SOLICITUDES_PROFESIONAL}
              label="Solicitudes Profesional"
              {...a11yProps(HCE_MENU_INFORMACION.SOLICITUDES_PROFESIONAL)}
            />
            {/* <Tab
              value={HCE_MENU_INFORMACION.DOCUMENTACION}
              label="Documentación"
              {...a11yProps(HCE_MENU_INFORMACION.DOCUMENTACION)}
            /> */}
          </Tabs>
          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.RESUMEN}>
            <TabResumen
              hce={hceSeleccionada}
              dataAfiliado={dataAfiliado}
              problemas={problemas}
              estadosProblemas={estadosProblemas}
              onCloseModalProblemas={props.closeModalHandler}
              disabled={disabled}
              autopercepcionAfi={autopercepcionAfi}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={HCE_MENU_INFORMACION.DIAGNOSTICOS}
          >
            <TabDiagnosticos
              hce={hceSeleccionada}
              //disabled={disabled}
              problemas={problemas}
              estadosProblemas={estadosProblemas}
              dataAfiliado={dataAfiliado}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.MEDICACION_INDICADA}>
            <TabMedicacionIndicada
              hce={hceSeleccionada}
              dataAfiliado={dataAfiliado}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.ENFERMERIA}>
            <TabEnfermeria
              hce={hceSeleccionada}
              dataAfiliado={dataAfiliado}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.ESTUDIOS_SOLICITADOS}>
            <TabEstudiosSolicitados
              hce={hceSeleccionada}
              dataAfiliado={dataAfiliado}
              disabled={disabled}
            />
          </TabPanel>

          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.RECETAS}>
            <TabRecetas
              hce={hceSeleccionada}
              dataAfiliado={dataAfiliado}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.INFORMES}>
            <TabInformes
              hce={hceSeleccionada}
              onCloseModalProblemas={props.closeModalHandler}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={HCE_MENU_INFORMACION.ANALISIS_CLINICOS}
          >
            <TabAnalisis onCloseModalProblemas={props.closeModalHandler} disabled={disabled} />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={HCE_MENU_INFORMACION.OFTALMOLOGIA}
          >
            <TabOftalmologia
              hce={hceSeleccionada}
              onCloseModalProblemas={props.closeModalHandler}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={HCE_MENU_INFORMACION.ODONTOLOGIA}
          >
            <TabOdontologia
              hce={hceSeleccionada}
              onCloseModalProblemas={props.closeModalHandler}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.TURNOS}>
            <TabTurnos
              hce={hceSeleccionada}
              dataAfiliado={dataAfiliado}
              onCloseModalHce={props.closeModalHandler}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel value={selectedTab} index={HCE_MENU_INFORMACION.CONSUMOS}>
            <TabConsumos
              afiliado={dataAfiliado}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={HCE_MENU_INFORMACION.SOLICITUDES_PROFESIONAL}
          >
            <TabSolicitudesProfesional
              hce={hceSeleccionada}
              disabled={disabled}
            />
          </TabPanel>
          <TabPanel
            value={selectedTab}
            index={HCE_MENU_INFORMACION.DOCUMENTACION}
          >
            <TabDocumentacionHce
              hce={hceSeleccionada}
              onCloseModalHce={props.closeModalHandler}
              disabled={disabled}
            //disabled={disabled}
            />
          </TabPanel>
        </DialogContent>
      </Dialog>
    </>
  );
};
